// client/src/components/influencer/project/modals/ContractConfirmModal.js
import React, { useState } from 'react';

function ContractConfirmModal({ open, onClose, onConfirm, project }) {
  const [loading, setLoading] = useState(false);

  if (!open || !project) return null;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="influencer-contract-modal" style={{ zIndex: 10002 }}>
      <div className="influencer-contract-modal__content" style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
        {/* X 버튼 */}
        <button 
          className="influencer-contract-modal__close" 
          onClick={onClose} 
          disabled={loading}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '32px',
            height: '32px',
            padding: '0',
            margin: '0',
            border: 'none',
            background: '#f3f4f6',
            borderRadius: '50%',
            fontSize: '26px',
            lineHeight: '0',
            cursor: loading ? 'not-allowed' : 'pointer',
            color: '#6b7280',
            transition: 'all 0.2s',
            fontFamily: 'Arial, sans-serif',
            fontWeight: '300',
            opacity: loading ? 0.5 : 1
          }}
        >
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'block'
          }}>
            ×
          </span>
        </button>

        {/* 제목 */}
        <h2 className="influencer-contract-modal__title">최종 계약 진행 확인</h2>
        
        {/* 안내 메시지 */}
        <div className="influencer-contract-modal__message-box">
          <div className="influencer-contract-modal__message-icon">⚠️</div>
          <div className="influencer-contract-modal__message">
            <div className="influencer-contract-modal__message-main">
              정말 계약을 진행하시겠습니까?
            </div>
            <div className="influencer-contract-modal__message-sub">
              계약 완료 후에는 취소할 수 없습니다.
            </div>
          </div>
        </div>

        {/* 프로젝트 요약 */}
        <div className="influencer-contract-modal__summary">
          <div className="influencer-contract-modal__summary-item">
            <span className="influencer-contract-modal__summary-label">프로젝트</span>
            <span className="influencer-contract-modal__summary-value">{project.projectNumber}</span>
          </div>
          <div className="influencer-contract-modal__summary-item">
            <span className="influencer-contract-modal__summary-label">기본 리워드</span>
            <span className="influencer-contract-modal__summary-value">
              {project.rewardPointPerCreator.toLocaleString()}P
            </span>
          </div>
          {project.perPurchaseReward?.use && (
            <div className="influencer-contract-modal__summary-item">
              <span className="influencer-contract-modal__summary-label">추가 리워드</span>
              <span className="influencer-contract-modal__summary-value">
                +{project.perPurchaseReward.rewardPerBuyer.toLocaleString()}P/건
              </span>
            </div>
          )}
        </div>

        {/* 버튼 */}
        <div className="influencer-contract-modal__actions">
          <button 
            className="influencer-contract-modal__button influencer-contract-modal__button--cancel"
            style={{ background: '#fff', color: '#6b7280', border: '1px solid #d1d5db' }}
            onClick={onClose}
            disabled={loading}
          >
            취소
          </button>
          <button 
            className="influencer-contract-modal__button influencer-contract-modal__button--confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? '처리 중...' : '계약 완료'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContractConfirmModal;

